/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetSyncCaseItemsParams = zod.object({
	thread_id: zod.string().optional(),
	root_case_id: zod.string().optional()
});

export type GetSyncCaseItemsParams = zod.input<typeof GetSyncCaseItemsParams>;
export type GetSyncCaseItemsParamsOutput = zod.output<typeof GetSyncCaseItemsParams>;
